import * as React from 'react';
import PropTypes from 'prop-types';
import Window from '../dialogs/Window';
import Grid from './Grid'
import "./Frm.scss";

const Frm = (props) => {
  const {
    selectedFrm,
    frmValue,
    frmId,
    level,
    modal,
    fixedFilter,
    onClose,
    componentFactory,
    reducer,
    filterFactory,
    akcFactory,
    currentElFactory,
    db,
    parent,
    initialWidth,
    initialHeight
  } = props;
  const title = selectedFrm ? `${selectedFrm.Name} ${selectedFrm.Title || ''}` : "";

  return (
    !!selectedFrm && <Window
      isOpen={!!selectedFrm}
      onClose={onClose}
      title={title}
      initialHeight={initialHeight ?? 0.8 * window.innerHeight}
      initialWidth={initialWidth ?? 0.8 * window.innerWidth}
      relativeTop={level * 30}
      relativeLeft={level * 30}
      level={level}
      resizable
      hideButtons
      modal={modal ? true : false}
    >
      <Grid
        primaryField={selectedFrm?.Identif}
        fixedFilter={fixedFilter}
        frmValue={frmValue}
        frmId={frmId}
        level={level + 1}
        componentFactory={componentFactory}
        reducer={reducer}
        filterFactory={filterFactory}
        akcFactory={akcFactory}
        currentElFactory={currentElFactory}
        db={db}
        parent={parent}
      />
    </Window>);

}

Frm.propTypes = {
  selectedFrm: PropTypes.object,
  frmId: PropTypes.number,
  level: PropTypes.number,
  coponentFactory: PropTypes.func,
  reducer: PropTypes.func,
  filterFactory: PropTypes.func,
  modal: PropTypes.bool,
  currentElFactory: PropTypes.func,
  db: PropTypes.string,
  initialWidth: PropTypes.number,
  initialHeight: PropTypes.number
}

export default Frm;